<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.groupName">
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.locationDetails',
            formControlNames: ['groupName', 'description', 'exportCode', 'exportGroupCode']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="groupName"
                                               [(ngModel)]="model.data.groupName"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="exportCode"
                                                   [(ngModel)]="model.data.exportCode"></wbo-text-edit-control>
                            <wbo-text-edit-control formControlName="exportGroupCode"
                                                   [(ngModel)]="model.data.exportGroupCode"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control *ngIf="model.data.outletGroupId"
                                               formControlName="fedeltaRestaurantId"
                                               [readonly]="true"
                                               [(ngModel)]="fedeltaRestaurantId"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.resDiary',
            visible: (License.RESDIARY | booleanConfig),
            formControlNames: ['resdiary_restaurantId', 'resdiary_secondSecret', 'resdiary_default_dining_time']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="resdiary_restaurantId"
                                                      [(ngModel)]="model.data.resdiary_restaurantId"></wbo-numeric-edit-control>
                            <wbo-text-edit-control formControlName="resdiary_secondSecret"
                                                   [(ngModel)]="model.data.resdiary_secondSecret"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="resdiary_default_dining_time"
                                                  [(ngModel)]="model.data.resdiary_default_dining_time"></wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.openTable',
            visible: (License.OPENTABLE | booleanConfig),
            formControlNames: ['openTableRestaurantId']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="openTableRestaurantId"
                                               [(ngModel)]="model.data.openTableRestaurantId"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.tyroConnect',
            visible: ( (License.TYROFOOD | booleanConfig) || (License.TYROBOOKING | booleanConfig)),
            formControlNames: ['tyroConnectLocationId']
        }">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control [(ngModel)]="model.data.tyroConnectLocationId"
                                           [overrideRequired]="true"
                                           formControlName="tyroConnectLocationId"></wbo-text-edit-control>
                </fui-column>
                <fui-column *ngIf="!requestingAccessToken">
                    <ng-container *ngIf="!tyroConnectRequestRefreshTokenUpdated">
                        <fui-inline-warning *ngIf="!model.data.tyroConnectRefreshToken && model.data.tyroConnectLocationId"
                                            [title]="'wbo.common.info.warning'">
                            <span>{{'wbo.location.edit.message.tyroAuthentication.notAuthenticated' | translate}}</span>
                            <br><br>
                            <a (click)="authenticateTyro()" *ngIf="!(editPageComponent?.editService?.$entityRestricted | async)" href="#"
                               onclick="return false;">{{'wbo.location.edit.message.tyroAuthentication.authenticate' | translate}}</a>
                            <br><br>
                        </fui-inline-warning>
                        <fui-inline-information *ngIf="model.data.tyroConnectRefreshToken"
                                                [title]="'wbo.common.info.information'">
                            <span>{{'wbo.location.edit.message.tyroAuthentication.authenticated' | translate}}</span>
                            <br><br>
                            <a (click)="authenticateTyro()" *ngIf="!(editPageComponent?.editService?.$entityRestricted | async)" href="#"
                               onclick="return false;">{{'wbo.location.edit.message.tyroAuthentication.reAuthenticate' | translate}}</a>
                            <br><br>
                        </fui-inline-information>
                    </ng-container>
                    <ng-container *ngIf="tyroConnectRequestRefreshTokenUpdated">
                        <fui-inline-information *ngIf="model.data.tyroConnectRefreshToken"
                                                [title]="'wbo.common.info.information'">
                            <span>{{'wbo.location.edit.message.tyroAuthentication.refreshTokenUpdated' | translate}}</span>
                        </fui-inline-information>
                    </ng-container>
                </fui-column>
                <fui-column *ngIf="requestingAccessToken">
                    <fui-inline-information [title]="'wbo.common.info.information'">
                        <span>{{'wbo.location.edit.message.tyroAuthentication.waitingAuthentication' | translate}}</span>
                        <br><br>
                        <a (click)="cancelAuthenticationTyroPool()" href="#"
                           onclick="return false;">{{'wbo.location.edit.message.tyroAuthentication.cancelWaitingAuthentication' | translate}}</a>
                        <br><br>
                    </fui-inline-information>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.yello',
            visible: (License.GIVEX | booleanConfig),
            formControlNames: ['yelloStoreId', 'yelloCheckEta']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="yelloStoreId"
                                                   [(ngModel)]="model.data.yelloStoreId"></wbo-text-edit-control>
                            <wbo-checkbox-edit-control formControlName="yelloCheckEta"
                                                       [(ngModel)]="model.data.yelloCheckEta"></wbo-checkbox-edit-control>
                        </fui-append-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.doordashdrive',
            visible: (License.DOORDASHDRIVE | booleanConfig),
            formControlNames: ['doordash_apiKey']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-prepend-field>
                            <wbo-checkbox-edit-control [(ngModel)]="model.data.doorDashEnabled"
                                                       formControlName="doorDashEnabled"></wbo-checkbox-edit-control>
                            <wbo-text-edit-control [(ngModel)]="model.data.doorDashBusinessName"
                                                   [overrideRequired]="model.data.doorDashEnabled"
                                                   formControlName="doorDashBusinessName"></wbo-text-edit-control>
                        </fui-prepend-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.location.edit.formation.givex',
            visible: (License.GIVEX | booleanConfig),
            formControlNames: ['givexStoreId', 'givexPassword']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="givexStoreId"
                                               [(ngModel)]="model.data.givexStoreId"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="givexPassword"
                                               [(ngModel)]="model.data.givexPassword"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
